"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.useSharedValueEffects = void 0;
const use_once_1 = require("../use-once");
const context_1 = require("./context");
function runEffects(values, effects) {
    effects.forEach(effect => effect(values));
}
function useSharedValueEffects(effects) {
    const values = context_1.useSharedValueStoreContext();
    use_once_1.useOnce(() => runEffects(values, effects));
}
exports.useSharedValueEffects = useSharedValueEffects;
//# sourceMappingURL=shared-value-effects.js.map